import { BaseModel } from './base';

export enum CustomerCreditCardProcessor {
  stripe = 0,
  square = 1,
}

export const CustomerCreditCardProcessorLabels: Record<CustomerCreditCardProcessor, string> = {
  [CustomerCreditCardProcessor.stripe]: 'integration.stripe.label',
  [CustomerCreditCardProcessor.square]: 'integration.square.label',
};

export enum CustomerCreditCardStatus {
  active = 0,
  expiringSoon = 1,
  expired = 2,
}

export const CustomerCreditCardStatusLabels: Record<CustomerCreditCardStatus, string> = {
  [CustomerCreditCardStatus.active]: 'general.active',
  [CustomerCreditCardStatus.expiringSoon]: 'customer.expiringSoon',
  [CustomerCreditCardStatus.expired]: 'general.expired',
};

export class CustomerCreditCard extends BaseModel {
  idCustomerCreditCard!: number;
  processor!: CustomerCreditCardProcessor;
  status!: CustomerCreditCardStatus;
  last4!: string;
  cardType!: string;

  override objectID(): string | null {
    return this.idCustomerCreditCard?.toString() ?? null;
  }

  get isProcessorStripe(): boolean {
    return this.processor === CustomerCreditCardProcessor.stripe;
  }

  get isProcessorSquare(): boolean {
    return this.processor === CustomerCreditCardProcessor.square;
  }

  get isStatusActive(): boolean {
    return this.status === CustomerCreditCardStatus.active;
  }

  get isStatusExpiringSoon(): boolean {
    return this.status === CustomerCreditCardStatus.expiringSoon;
  }

  get isStatusExpired(): boolean {
    return this.status === CustomerCreditCardStatus.expired;
  }
}
